import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {AuthService, requiredFieldValidator} from 'common-domain';
import {ActivatedRoute} from "@angular/router";
import {jwtDecode} from 'jwt-decode';

@Component({
    template: ``,
    standalone: false
})
export abstract class TwoFactorGenericComponent implements OnInit {
  form: FormGroup;
  errorMessage: string;

  protected constructor(protected authService: AuthService, protected formBuilder: FormBuilder, protected activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      code: new FormControl('', [requiredFieldValidator])
    });
  }

  onSubmit() {
    if (this.form.valid) {
      const token = this.activatedRoute.snapshot.paramMap.get('token');
      const mfaCode = this.form.get('code').value;
      const decodedToken = this.getDecodedAccessToken(token);
      this.onSubmitInfo(token, mfaCode, decodedToken);
    }
  }

  abstract onSubmitInfo(token: string, mfaCode: string, decodedToken: any): void;
  getDecodedAccessToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (Error) {
      return undefined;
    }
  }
}
